import { fetch } from '@/utils/http'

export default {
  getNodeManageList: params =>
    fetch('get', '/cbaas-service/v1/nodeManagement/queryNodeList', params),
  createNode: params => fetch('post', '/cbaas-service/v1/nodeManagement/createNode', params),
  deleteNode: params => fetch('post', '/cbaas-service/v1/nodeManagement/deleteNode', params),
  operateNode: params => fetch('get', '/cbaas-service/v1/nodeManagement/nodeOp', params)
}
